import React from 'react';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import type { DemoDomain } from '../../data/demoCenter';
import { DomainIcon } from './DomainIcon';
import { DemoStatusBadge } from './DemoStatusBadge';
type DomainCardProps = {
  domain: DemoDomain;
  highlighted: boolean;
  onExplore: (domain: DemoDomain) => void;
};
const focusRing = 'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal';
export function DomainCard({
  domain,
  highlighted,
  onExplore
}: DomainCardProps) {
  const titleId = `${domain.id}-title`;
  return <article id={domain.id} aria-labelledby={titleId} className={`scroll-mt-24 flex h-full flex-col rounded-xl border bg-white/80 backdrop-blur-sm p-6 lg:p-7 shadow-premium transition-[border-color,box-shadow] duration-200 ${highlighted ? 'border-lavender ring-2 ring-lavender/30' : 'border-line'}`} data-id="element-246" data-mp="2h8apw839aes1">
      <div className="flex items-start justify-between gap-4" data-id="element-247" data-mp="1ftt7vnpax0l">
        <DomainIcon id={domain.id} data-id="element-248" data-mp="2w7kmld8gx4w6" />
        <DemoStatusBadge status={domain.status} data-id="element-249" data-mp="2w6jd3d73oqgk" />
      </div>

      <p className="mt-6 text-sm font-medium text-lavender" data-id="element-250" data-mp="2r8znxi8v6t9u">{domain.solutionLabel}</p>
      <h3 id={titleId} className="mt-1 font-heading font-bold text-xl text-ink-dark leading-snug" data-id="element-251" data-mp="2n74ko87di5tf">
        {domain.title}
      </h3>
      <p className="mt-3 text-ink-muted leading-relaxed" data-id="element-252" data-mp="2i8ute8orrpd3">{domain.description}</p>

      <div className="mt-auto pt-6" data-id="element-253" data-mp="2d9i47hafe67c">
        <p className="text-xs font-medium text-ink-muted mb-2" data-id="element-254" data-mp="2dajgfp36gyqn">Workspaces</p>
        <ul aria-label={`${domain.title} workspaces`} className="flex flex-wrap gap-2" data-id="element-255" data-mp="28i06d23p8lql">
          {domain.workspaces.map(workspace => <li key={workspace} className="rounded-md border border-line bg-surface-bg px-2.5 py-1 text-xs font-medium text-ink-dark" data-id="element-256" data-mp="23h2mml31jjmz">
              {workspace}
            </li>)}
        </ul>

        <div className="mt-6 pt-5 border-t border-line" data-id="element-257" data-mp="1piuk7xn8jq4f">
          {domain.status === 'interactive' && domain.demoUrl ? <a id={`${domain.id}-action`} href={domain.demoUrl} target="_blank" rel="noopener noreferrer" className={`inline-flex w-full items-center justify-center gap-2 rounded-md bg-navy px-5 py-3 font-semibold text-white hover:bg-navy-light transition-colors duration-150 whitespace-nowrap ${focusRing}`} data-id="element-258" data-mp="1fuyzdrk0b9zs">
              {domain.actionLabel}
              <ArrowUpRight size={18} aria-hidden="true" data-id="element-259" data-mp="1yocohg11gm7h" />
              <span className="sr-only" data-id="element-260" data-mp="23kb5ujny93ye">(opens in a new tab)</span>
            </a> : <button id={`${domain.id}-action`} type="button" aria-haspopup="dialog" onClick={() => onExplore(domain)} className={`inline-flex w-full items-center justify-center gap-2 rounded-md border border-line bg-white px-5 py-3 font-semibold text-navy hover:bg-surface-muted hover:border-navy-light transition-colors duration-150 whitespace-nowrap ${focusRing}`} data-id="element-261" data-mp="1ovf0wvh6w720">
              {domain.actionLabel}
              <ArrowRight size={18} aria-hidden="true" data-id="element-262" data-mp="5ya99kmhfjhi" />
              <span className="sr-only" data-id="element-263" data-mp="5vo4ttuw1k3i">: {domain.title}</span>
            </button>}
        </div>
      </div>
    </article>;
}